
import { Shell } from "@/components/layout/Shell";
import { CategoryForm } from "@/components/categories/CategoryForm";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Category } from "@/lib/types";
import { toast } from "sonner";

export default function CategoryCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSuccess = (category: Category) => {
    toast.success("Category created successfully");
    navigate("/categories");
  };

  const handleCancel = () => {
    navigate("/categories");
  };

  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('createNewCategory')}</h1>
          <p className="text-muted-foreground mt-2">
            {t('addNewCategory')}
          </p>
        </div>

        <CategoryForm 
          mode="create" 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </Shell>
  );
}
